/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import pkg from '../../../package.json'

/**
 * Returns the app name.
 */
export function getAppName (): string {
  return pkg.name
}

/**
 * Returns the app version.
 */
export function getAppVersion (): string {
  return pkg.version
}
